import { useRouteError } from "react-router-dom";
import './ErrorPage.css'
import {ChakraProvider} from "@chakra-ui/react";
import Navi from "../components/Navi";
import React from "react";

function ErrorPage() {
    const error = useRouteError() as any;
    console.error(error);

    return (
        <ChakraProvider>
            <div className="App" style={{display: "flex", flexDirection: "column", justifyContent: "space-between", height: '100%'}}>
                <Navi />
                <main style={{height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    <div id={"apperror-page"}>
                        <h1>Oops!</h1>
                        <p>Sorry, an unexpected error has occurred.</p>
                        <p>
                            <i>{error.statusText || error.message}</i>
                        </p>
                    </div>
                </main>
            </div>
        </ChakraProvider>
    );
}

export default ErrorPage;
